// extracted by mini-css-extract-plugin
export default {"body":"Funds_body__I6U8R"};